// storage.ts
export const tokenStorage = {
    set: (key: string, value: string) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem(key, value);
        }
    },
    get: (key: string): string | null => {
        if (typeof window !== 'undefined') {
            return localStorage.getItem(key);
        }
        return null;
    },
    clearAll: () => {
        if (typeof window !== 'undefined') {
            localStorage.clear();
        }
    },
};